"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkHealth = void 0;
const shared_1 = require("@getgreenline/shared");
const convertFromXmlToJson_1 = require("../../../models/worldpay/transaction/helpers/xmlParser/convertFromXmlToJson");
const convertHealthCheckFromJsonToXml_1 = require("../../../models/worldpay/system/helpers/convertHealthCheckFromJsonToXml");
const findNestedObjectValue_1 = require("../../../models/worldpay/system/helpers/findNestedObjectValue");
const checkHealth = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const xml = (0, convertHealthCheckFromJsonToXml_1.convertHealthCheckFromJsonToXml)(params);
    const res = yield shared_1.axios.post(params.apiUrl, xml, {
        headers: { 'Content-Type': 'text/xml' },
    });
    const json = (0, convertFromXmlToJson_1.convertFromXmlToJson)(res.data);
    const expressResponseCode = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseCode');
    const expressResponseMessage = (0, findNestedObjectValue_1.findNestedObjectValue)(json, 'ExpressResponseMessage');
    if (expressResponseCode === undefined)
        throw Error('ExpressResponseCode not found in response');
    return {
        expressResponseCode,
        expressResponseMessage,
        response: json,
    };
});
exports.checkHealth = checkHealth;
//# sourceMappingURL=WorldpaySystemAPI.js.map